import axios from '../config/axios';
import StorageService from '../services/StorageService';

class BalanceHttpService {
    static async getBalances(page = 1, limit = 20, search) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/balance`,
                {
                    params: {
                        page,
                        limit,
                        search
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async applyYield(percentage, date) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/balance/yield`,
                { percentage, date },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async uploadCashbackCSV(formData) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/balance/upload-cashback`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getUserBalanceHistory(userId, page = 1, limit = 10) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/balance/logs/${userId}`,
                {
                    params: {
                        page,
                        limit
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async applyLogCashbackYield(logId, percentage) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/balance/log-cashback/${logId}`,
                { percentage },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getUserBalanceLogs(page = 1, limit = 20) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/balance/logs/${StorageService.getAuth()?.user?.id}`,
                {
                    params: {
                        page,
                        limit
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
}

export default BalanceHttpService;
